import { Box, Paper, Typography, makeStyles } from "@material-ui/core";
import { Error, Loading } from "ra-ui-materialui";
import useMerchantSetting from "../hooks/useMerchantSetting";

const useStyles = makeStyles(() => ({
  allContainer: {
    width: 1024,
  },
}));

const MerchantSetting = () => {
  const classes = useStyles();
  const { setting, loading, error } = useMerchantSetting();
  if (loading) return <Loading />;
  if (error) return <Error />;
  return (
    <Paper classes={{ root: classes.allContainer }}>
      <SettingView setting={setting} />
    </Paper>
  );
};

const useSettingViewStyle = makeStyles(() => ({
  container: {
    marginTop: 50,
    width: "100%",
  },
}));

const SettingView = ({ setting }) => {
  const classes = useSettingViewStyle();

  return (
    <Box className={classes.container}>
      <Typography>{JSON.stringify(setting)}</Typography>
    </Box>
  );
};

export default MerchantSetting;
